import React, { useState, useEffect, useCallback } from 'react';
import { Table, Button, Typography } from 'antd';
import { getSalary } from '../../../../../api/EmiPayments';
import { useSelector } from 'react-redux';
import { CURRENCY } from '../../../../../utils/ConstantData';
import { CurrencyFormatWithDecimal } from '../../../../../helper/CurrencyFormate';
import { TabsEnum } from '../../../../../utils/Enum/ReportTabsEnum';

const SalaryReport = ({ onClickTabChange = () => {} }) => {
  const [salary, setSalary] = useState([]);
  const { reportDetails, selectedAccountId } = useSelector(({ reportDetails }) => reportDetails);

  const fetchData = useCallback(async (accountId) => {
    try {
      const aggregate = accountId !== 'all' ? false : true;
      const account_id = accountId !== 'all' ? accountId : reportDetails?.report?.reportId;

      const response = await getSalary(account_id, aggregate, "salary");

      const mappedData = response.salary.map((item) => ({
        ...item,
        debit: item.transactionType === "DB" ? parseFloat(item.amount) : null,
        credit: item.transactionType === "CR" ? parseFloat(item.amount) : null,
      }));

      setSalary(mappedData);
    } catch (error) {
      console.log("ERROR", error);
    }
  }, [reportDetails]);

  useEffect(() => {
    if (selectedAccountId) {
      fetchData(selectedAccountId);
    }
  }, [selectedAccountId, fetchData]);

  const handleTabChange = useCallback(() => {
    onClickTabChange(TabsEnum.TRANSACTION);
  }, [onClickTabChange]);

  const columns = [
    {
      title: 'Start Date',
      dataIndex: 'startDate',
      key: 'startDate',
    },
    {
      title: 'End Date',
      dataIndex: 'endDate',
      key: 'endDate',
    },
    {
      title: 'Particulars',
      dataIndex: 'particulars',
      key: 'particulars',
    },
    {
      title: 'Counterparty',
      dataIndex: 'counterparty',
      key: 'counterparty',
    },
    {
      title: `Debit (${CURRENCY})`,
      dataIndex: 'debit',
      key: 'debit',
      align: 'right',
      className: 'no-wrap-column',
      render: (value) => (
        <Typography.Text {...(value < 0 ? { type: "danger" } : {})}>
          {CurrencyFormatWithDecimal(value, null, CURRENCY)}
        </Typography.Text>
      ),
    },
    {
      title: `Credit (${CURRENCY})`,
      dataIndex: 'credit',
      key: 'credit',
      className: 'no-wrap-column',
      align: 'right',
      render: (value) => (
        <Typography.Text {...(value < 0 ? { type: "danger" } : {})}>
          {CurrencyFormatWithDecimal(value, null, CURRENCY)}
        </Typography.Text>
      ),
    },
    {
      title: 'Interval',
      dataIndex: 'interval',
      key: 'interval',
    },
    {
      title: 'Txn Count',
      dataIndex: 'transactionCount',
      key: 'transactionCount',
      render: (value) =>
        parseFloat(value) > 0 ? (
          <Button
            style={{ paddingInline: 4 }}
            color="primary"
            variant="link"
            onClick={handleTabChange}
          >
            {value}
          </Button>
        ) : (
          value
        ),
    },
    {
      title: 'Misses',
      dataIndex: 'misses',
      key: 'misses',
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={salary}
      pagination={{ pageSize: 100 }}
      scroll={{ x: true }}
      rowKey="startDate"
    />
  );
};

export default SalaryReport;
